import { render, staticRenderFns } from "./SubcontractEditor.vue?vue&type=template&id=03679142&"
import script from "./SubcontractEditor.vue?vue&type=script&lang=js&"
export * from "./SubcontractEditor.vue?vue&type=script&lang=js&"
import style0 from "./SubcontractEditor.vue?vue&type=style&index=0&id=03679142&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports